import { useState } from "react";

import { useSelector } from "react-redux";

import { ListItemText, Button, Typography, Menu, MenuItem, ListItemIcon } from "@mui/material"

import { FaPlus } from "react-icons/fa";
import { FaFolderTree } from "react-icons/fa6";
import { FaChevronDown } from "react-icons/fa6";
import { FaListCheck } from "react-icons/fa6";

import { RootState } from "../../store";

import { ListItembuttonStyle, ListItemIconStyle, ListTypographyStyle, MenuItemStyle, TypographyAppBarStyle, ListItemTextStyle } from '../../styles/ListItemStyle';
import { DialogNuevaRecepcion } from "../../dialogs/DialogNuevaRecepcion";
import { DialogNuevoListadoEntrega } from "../../dialogs/DialogNuevoListadoEntrega";

export const ListItemNuevo = () => {

    const { roles } = useSelector( ( state: RootState ) => state.auth );

    const [anchorEl, anchorElOpen] = useState<null | HTMLElement>( null );

    const [openDialogNuevaRecepcion, setOpenDialogNuevaRecepcion] = useState( false );
    const [openDialogNuevoListadoEntrega, setOpenDialogNuevoListadoEntrega] = useState( false );

    const open = Boolean(anchorEl);

    const handleOpen = ( e: React.MouseEvent<HTMLButtonElement, MouseEvent> ) => {
        anchorElOpen( e.currentTarget );
    };
  
    const handleClose = () => {
        anchorElOpen( null );
    };

    return (
        <>

            <ListItemText style={ ListItemTextStyle }>

                <Button color="inherit" style={ ListItembuttonStyle } onClick={ handleOpen }>

                    <FaPlus style={ ListItemIconStyle } />

                    <Typography sx={{ ...ListTypographyStyle, display: { xs: 'none', lg: 'flex' } }} >
                        Nuevo
                    </Typography>

                    <FaChevronDown style={ ListItemIconStyle } />
                                            
                </Button>

            </ListItemText>  

            <Menu 
                elevation={ 2 } 
                anchorEl={ anchorEl } 
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }} 
                keepMounted open={ open } 
                onClose={ handleClose }
                sx={{ width: 320 }}
            >

                {
                    roles?.RegistradorInformacion
                    &&
                        <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ () => { setOpenDialogNuevaRecepcion( true ); handleClose(); } }> 
                            <ListItemIcon style={ ListItemIconStyle }> <FaFolderTree /> </ListItemIcon>
                            <ListItemText style={TypographyAppBarStyle}>Recibir trámite</ListItemText>
                        </MenuItem>   
                }
        
                {
                    roles?.GeneradorListadoEntrega
                    &&
                        <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ () => { setOpenDialogNuevoListadoEntrega( true ); handleClose(); } }> 
                            <ListItemIcon style={ ListItemIconStyle }> <FaListCheck /> </ListItemIcon>
                            <ListItemText style={TypographyAppBarStyle}>Gestionar listado de entrega</ListItemText>
                        </MenuItem>   
                }

            </Menu>

            <DialogNuevaRecepcion
                openDialog={ openDialogNuevaRecepcion }
                handleCloseDialog={ () => setOpenDialogNuevaRecepcion( false ) }
            />

            <DialogNuevoListadoEntrega
                openDialog={ openDialogNuevoListadoEntrega }
                handleCloseDialog={ () => setOpenDialogNuevoListadoEntrega( false ) }
            />
        
        </>
    )
}
